(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript.closest('.cbx-collection');
  if(!root) return;
  const hero = root.querySelector('.cbx-hero');
  const sidebar = root.querySelector('.cbx-sidebar');
  const scroller = root.querySelector('.cbx-mobile-scroller');

  // Push sidebar down to start under the hero (desktop only)
  function offsetSidebar(){
    if (!hero || !sidebar) return;
    const mq = window.matchMedia('(max-width: 1024px)');
    if (mq.matches){
      sidebar.style.setProperty('--hero-offset', '0px');
      return;
    }
    const h = hero.offsetHeight || 0;
    sidebar.style.setProperty('--hero-offset', h + 'px');
  }

  window.addEventListener('resize', offsetSidebar);
  window.addEventListener('load', offsetSidebar);
  const img = hero ? hero.querySelector('img') : null;
  if (img) img.addEventListener('load', offsetSidebar);
  offsetSidebar();

  // Allow vertical wheel to scroll the mobile pill bar horizontally
  if (scroller){
    scroller.addEventListener('wheel', (e)=>{
      if(Math.abs(e.deltaX) < Math.abs(e.deltaY)){
        scroller.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, {passive:false});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".product_slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".product_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".product_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reveiw-slider"] && !Shopify.designMode) return;
  try {
    
  $('.customerslider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: true,
  infinite: true,
  responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-with-sidebar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript && document.currentScript.closest('.cbx-faq');
    if (!root) return;

    // Read sticky offset from data-attribute; fallback to CSS var; finally to 72
    let offset = parseInt(root.dataset.stickyOffset, 10);
    if (isNaN(offset) || offset <= 0) {
      const scroller = root.querySelector('.cbx-mobile-scroller');
      if (scroller) {
        const v = getComputedStyle(scroller).getPropertyValue('--faq-sticky-offset').trim();
        const n = parseInt(v, 10);
        if (!isNaN(n)) offset = n;
      }
    }
    if (isNaN(offset) || offset <= 0) offset = 72;

    function openAndScrollTo(hash) {
      if (!hash || hash === '#') return;
      const id = hash.charAt(0) === '#' ? hash.slice(1) : hash;
      const section = document.getElementById(id);
      if (!section) return;
      const y = section.getBoundingClientRect().top + window.scrollY - offset - 8;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    // In-page anchor clicks only (for in-section bar)
    root.addEventListener(
      'click',
      (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const href = a.getAttribute('href') || '';
        if (!href || href === '#') return;
        e.preventDefault();
        openAndScrollTo(href);
        if (history && history.replaceState) history.replaceState(null, '', href);
      },
      { passive: true }
    );

    if (location.hash) {
      setTimeout(() => openAndScrollTo(location.hash), 50);
    }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-article"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-review"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".rev_slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: false,
        autoplay: false,
        dots: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 1,
                dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                dots: true,
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".rev_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".rev_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".product_slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".product_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".product_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
